import { PurchaseOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0530. 発注案件登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  name: string;
  description: string;
  user_id: number;
  business_partner_id: number;
  person_in_charge?: string;
  payment_context_id: number;
  spot_amount?: number;
  spot_billing_date?: string;
  monthly_amount?: number;
  monthly_billing_start_date?: string;
  monthly_billing_end_date?: string;
  contract_start_date?: string;
  contract_end_date?: string;
  delivery_date?: string;
  payment_method_id: number;
  transfer_information?: string;
  fixed_asset_target: boolean;
  expense_account_item_ids: number[];
  prev_purchase_order_id?: number;
};
const createPurchaseOrder = (props: Props): Promise<PurchaseOrder> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders`, props);
};

export const useCreatePurchaseOrder = () => {
  return useMutation({
    mutationFn: createPurchaseOrder,
  });
};
